<template>
    <div class="or-about-card">
        <img :class="['image', card.image_position]" :src="card.image"/>
        <div :class="['text-container', 'flex-column', 'flex-center', card.image_position === 'left' ? 'right' : 'left']">
            <div v-html="text" class="text">
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
export default {
    props: {
        card: Object,
    },
    mounted() {
    },
    computed: {
        text() {
            const div = document.createElement('div');
            this.convertText({text: this.card.text, container: div});
            return div.innerHTML;
        }
    },
    methods: {
        ...mapActions({convertText: 'convertText'}),
    }
}
</script>

<style scoped>
    .or-about-card {
        position: relative;
        margin: 0 auto;
        width: 1100px;
        height: 300px;
        background-color: #1e1e1e;
        border-radius: 8px;
        overflow: hidden;
    }
    .image {
        width: 452px;
        height: 300px;
        object-position: center;
        object-fit: cover;
    }
    .left {
        position: absolute;
        left: 0;
    }
    .right {
        position: absolute;
        right: 0;
    }
    .text-container {
        width: 648px;
        height: 300px;
    }
    .text {
        font-size: 14px;
        line-height: 21px;
        text-align: left;
        width: 548px;
        max-height: 280px;
    }
</style>